import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import WidgetParametersEdit from './WidgetParametersEdit';
import StringField from '../../../_common/platform/tsx/StringField';
import { ProgressBar } from '../../../_common/platform/tsx/ProgressBar';

import { WidgetTypeSelect } from './WidgetTypeSelect';

function getState() {
    return this.props.glob.TemplateEditStore.getState();
}

export class TemplateEdit extends React.Component<any, any> {
    //LL: 03.20.25 
    private references: {
        container?: HTMLElement; // HTMLDivElement;
        dialog?: HTMLElement; // HTMLDivElement;
        header?: HTMLElement; // HTMLDivElement;
        footer?: HTMLElement; // HTMLDivElement;
        title?: HTMLElement; // HTMLDivElement;
    } = {};

    constructor(props) {
        super(props);

        this.state = _.extend(
            {},
            getState.call(this),
            {
                containerSize: 0,
                resized: false
            }
        );
    }

    _onChange = () => {
        this.setState(getState.call(this));
    };

    _getStyle = () => {
        return {};
    };

    componentDidMount() {
        this.props.glob.TemplateEditStore.addChangeListener(this._onChange);

        let dialog = this.references.dialog;

        $(dialog)
            .draggable({
                handle: '.drag-handle'
                //containment: 'document'
            })
            .resizable({
                start: this.startResize,
                resize: this.processContainerResize
            });

        this.setContainerSize();

        $(window).on('resize', this.setContainerSize);
    }

    componentWillUnmount() {
        this.props.glob.TemplateEditStore.removeChangeListener(this._onChange);

        let dialog = this.references.dialog;

        $(dialog).draggable('destroy');
        $(dialog).resizable('destroy');

        $(window).off('resize', this.setContainerSize);
    }

    startResize = () => {
        this.setState({
            resized: true
        });

        this.processContainerResize();
    };

    processContainerResize = () => {
        let dialog = this.references.dialog;
        let header = this.references.header;
        let footer = this.references.footer;
        
        this.setState({
            containerSize: $(dialog).height() - $(header).outerHeight() - $(footer).outerHeight()
        });
    };

    setContainerSize = () => {
        if (this.state.resized === true) {
            return;
        }

        let container = this.references.container;
        let header = this.references.header;
        let footer = this.references.footer;

        this.setState({
            containerSize: $(container).height() - $(header).outerHeight() - $(footer).outerHeight()
        });
    };

    create = (e) => {
        if (
            this.state.actionLoading ||
            this.state.dirId == null ||
            !this.state.data.widget ||
            this.state.data.widget.isInvalid
        ) {
            return;
        }

        this.props.glob.AppActions.templateCreateSave(
            this.state.dirId,
            (this.references.title as HTMLInputElement)?.value, //LL: was refs.title, but not defined
            this.state.data.getString()
        );
    };

    save = (e) => {
        if (
            this.state.actionLoading ||
            this.state.id == null ||
            !this.state.data.widget ||
            this.state.data.widget.isInvalid
        ) {
            return;
        }

        this.props.glob.AppActions.templateSave(this.state.id, this.state.data.getString());
        this.rename(this.state.name);
        this.goBack(e);
    };

    remove = (e) => {
        this.goBack(e);

        this.props.glob.AppActions.templateRemove(this.state.id);
    };

    rename = (val) => {
        if (this.state.actionLoading || this.state.id == null) {
            return;
        }

        this.props.glob.AppActions.templateRename(this.state.id, val);
    };

    goBack = (e) => {
        this.props.glob.AppActions.templateHide(this.props.wtid);
    };

    _getActionButtons = () => {
        let arr = [];

        if (this.state.data == null) {
            return;
        }

        if (this.state.id == null) {
            arr.push(
                <button
                    key="create"
                    className="btn btn-success"
                    onClick={this.create}
                    disabled={this.state.actionLoading}
                >
                    {'Create'}
                </button>
            );
        } else {
            arr.push(
                <button key="save" className="btn btn-success" onClick={this.save} disabled={this.state.actionLoading}>
                    {'Save'}
                </button>
            );
        }

        return arr;
    };

    setFieldValues = (id, type, values) => {
        this.props.glob.AppActions.configSetFieldValues(id, type, values);
    };

    handleOnSetWidgetType = (id: number, type: string) => {
        this.props.glob.AppActions.configSetWidgetType(id, type);
    };

    _getView = () => {
        let content = [];

        content.push(
            <WidgetTypeSelect
                key="TypeSelect"
                id={this.state.id}
                type={this.state.data.type}
                onUpdate={this.setContainerSize}
                onSetWidgetType={this.handleOnSetWidgetType}
                glob={this.props.glob}
            />
        );

        content.push(
            <WidgetParametersEdit
                key="ParametersEdit"
                id={this.state.id}
                type={this.state.data.type}
                data={this.state.data.widget}
                loading={this.state.data.loading}
                onUpdate={this.setContainerSize}
                onSetFieldValues={this.setFieldValues}
                glob={this.props.glob}
            />
        );

        // content.push(
        //     <pre className="template-json"
        //         key='Template'
        //     >
        //         {
        //             this.state.data.getPrettyString()
        //         }
        //     </pre>
        // );

        return content;
    };

    _getIncompatibleMessage = () => {
        return <pre>{'Incompatible JSON format'}</pre>;
    };

    _getContent = () => {
        if (this.state.loading) {
            return <ProgressBar />;
        }

        if (this.state.data == null) {
            return this._getIncompatibleMessage();
        } else {
            return this._getView();
        }
    };

    onChangeTitle = (value) => {
        this.setState({
            name: value
        });
    };

    render() {
        let nameInput;

        let bodyStyle = {
            maxHeight: this.state.containerSize
        };

        if (!this.state.loading) {
            nameInput = [
                <span className="name-field-title" key={'name-field-title'}>
                    Name →
                </span>,

                <StringField
                    // ref={(input) => {
                    //     this.references.title = input;
                    // }} //LL: 03.20.25 try, ref was not here
                    key={'name-string-title'}
                    readOnly={this.state.actionLoading}
                    onChange={this.onChangeTitle}
                    value={this.state.name != null ? this.state.name : 'New template'}
                />
            ];
        }

        return (
            <div className="template-edit">
                <div className="modal fade show" style={this._getStyle()} role="dialog">
                    <div className="modal-dialog mw-100" 
                        ref={(input) => {
                            this.references.container = input;
                        }} //LL: 03.20.25
                    >
                        <div className="modal-content" 
                            ref={(input) => {
                                this.references.dialog = input;
                            }} //LL: 03.20.25
                        >
                            <div className="modal-header" 
                                ref={(input) => {
                                    this.references.header = input;
                                }} //LL: 03.20.25
                            >
                                <div className="drag-handle"></div>

                                <h4 className="modal-title">{nameInput}</h4>

                                <button type="button" className="close" onClick={this.goBack}>
                                    &times;
                                </button>
                            </div>

                            <div className="modal-body container-fluid" style={bodyStyle}>
                                {this._getContent()}
                            </div>

                            <div className="modal-footer" 
                                ref={(input) => {
                                    this.references.footer = input;
                                }} //LL: 03.20.25
                            >
                                {this._getActionButtons()}
                                <button type="button" className="btn btn-default" onClick={this.goBack}>
                                    {'Cancel'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-backdrop fade show"></div>
            </div>
        );
    }
}
